/**
 * URL shim: maps the legacy /api/v1/* paths used by apps/web-app to the canonical /api/* paths.
 * This allows the migrated routes to call familiar URLs while we consolidate the API surface.
 */
const V1_TO_V0: Record<string, string> = {
  "/api/v1/auth/login":            "/api/auth/login",
  "/api/v1/auth/refresh":          "/api/auth/refresh",
  "/api/v1/auth/logout":           "/api/auth/logout",
  "/api/v1/auth/me":               "/api/auth/me",
  "/api/v1/auth/change-password":  "/api/auth/change-password",
  "/api/v1/auth/mfa/setup":        "/api/auth/mfa/setup",
  "/api/v1/patients":              "/api/patients",
  "/api/v1/consultations":         "/api/consultations",
  "/api/v1/prescriptions":         "/api/prescriptions",
  "/api/v1/dispensations":         "/api/pharmacy/dispense",
  "/api/v1/lab-orders":            "/api/lab/orders",
  "/api/v1/imaging-orders":        "/api/radiology/orders",
  "/api/v1/imaging/studies":       "/api/radiology/studies",
  "/api/v1/ald/requests":          "/api/ald/requests",
  "/api/v1/claims":                "/api/billing/invoices",
  "/api/v1/audit":                 "/api/audit",
  "/api/v1/users":                 "/api/config/users",
  "/api/v1/catalog/specialties":   "/api/config/specialties",
  "/api/v1/catalog/medications":    "/api/pharmacy/drugs",
  "/api/v1/catalog/devices":       "/api/radiology/modalities",
  "/api/v1/terminology/cim10":     "/api/terminology/cim10",
  "/api/v1/terminology/ngap":      "/api/terminology/ngap",
  "/api/v1/device/profiles":       "/api/device/profiles",
  "/api/v1/device/endpoints":      "/api/device/endpoints",
  "/api/v1/device/vendors":        "/api/device/vendors",
  "/api/v1/device/simulators/profiles": "/api/device/simulators/profiles",
  "/api/v1/device/simulators/stats":    "/api/device/simulators/stats",
  "/api/v1/device/simulators/start":    "/api/device/simulators/start",
  "/api/v1/device/simulators/stop":     "/api/device/simulators/stop",
  "/api/v1/device/observations/recent": "/api/device/observations/recent",
  "/api/v1/imaging/orthanc/stats":       "/api/imaging/orthanc/stats",
  "/api/v1/imaging/dcm4chee/stats":      "/api/imaging/dcm4chee/stats",
};

export function resolveV1(url: string): string {
  if (url.startsWith("/api/v1/")) {
    const mapped = V1_TO_V0[url.split("?")[0]] ?? url.replace("/api/v1/", "/api/");
    return mapped + (url.includes("?") ? url.slice(url.indexOf("?")) : "");
  }
  return url;
}
